import { useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';
import { userLogout } from 'queries/ossix/auth/userLogin';
import { useNavigate } from 'react-router-dom';
import urls from 'routes/urls';
import endPoints from 'utils/platformEndPoints/ossix';

export default () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [api, contextHolder] = notification.useNotification();
  const {
    loadLogoutUser,
    mutate: requestLogout,
    clearData: clearLogoutRequest,
  } = userLogout();

  const handleInvalidateCache = () => {
    queryClient.invalidateQueries({
      queryKey: [endPoints.GetUserData],
      exact: true,
    });
  };

  const handleRemoveCache = () => {
    queryClient.removeQueries({
      queryKey: [endPoints.GetUserData],
      exact: true,
    });
  };

  const performLogout = () => {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userRefreshToken');
    localStorage.removeItem('rtsToken');
    localStorage.removeItem('PID');
    localStorage.removeItem('UserShouldSetPassword');
    localStorage.removeItem('respondedTo');
    localStorage.removeItem('fromUserLogout');
    localStorage.removeItem('debug_checkUserCredential_pureData');
    localStorage.removeItem('debug_checkUserCredential_successData');
    localStorage.removeItem('fromUserLogout');
    localStorage.removeItem('opt-page-refreshed-id');
    localStorage.removeItem('userWasIdle');
    localStorage.removeItem('userPID');
    clearLogoutRequest();
    handleRemoveCache();
    handleInvalidateCache();
    navigate(urls.login, { replace: true });
    window.location.reload();
  };

  const onHandleLogout = () => {
    requestLogout(
      {},
      {
        onSuccess: performLogout,
        onError: performLogout,
      },
    );
    performLogout();
  };

  return {
    contextHolder,
    onHandleLogout,
    loadLogoutUser,
  };
};
